import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import { Tooltip } from "@ubnt/store.core/lib/components/Tooltip";
import { Tabs } from "@ubnt/ui-components/Tabs";
import styled, { createGlobalStyle, css } from "styled-components";

export const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 40px;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    padding: 0 16px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
}
`;

export const ActiveVideoWrapper = styled.div`
  aspect-ratio: 1839 / 860;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  height: 100%;
  width: 100%;
  border-radius: 16px;
  background: #f7f7f7;
  opacity: 1;
  transition: opacity 0.3s ease-in;
`;

export const ActiveVideo = styled.video<{
  $isActive?: boolean;
}>`
  position: absolute;
  left: 0;
  top: 0;
  background: #f7f7f7;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0;
  transition: opacity 1.5s ease-out;

  ${({ $isActive }) =>
    $isActive &&
    css`
      transition: opacity 0.2s ease-in;
      z-index: 1;
      opacity: 1;
    `}
`;
export const BackgroundVideo = styled.video<{
  $isVisible: boolean;
}>`
  height: 100%;
  width: 100%;
  aspect-ratio: 1839 / 860;
  border-radius: 16px;
  position: relative;
  background: #f7f7f7;
  z-index: 5;
  opacity: 1;

  ${({ $isVisible }) =>
    !$isVisible &&
    css`
      transition: opacity 0.2s ease-out;
      transition-delay: 0.2s;
      opacity: 0;
    `}
`;

export const Title = styled.h1`
  color: #212427;
  font-size: 30px;
  font-weight: 700;
  line-height: normal;
  position: relative;
  margin: 0;
  z-index: 8;
  text-align: center;
  text-wrap: pretty;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 24px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 20px;
  }
`;

export const Description = styled.p`
  margin: 0;
  color: #808893;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
`;

export const Content = styled.div`
  position: absolute;
  top: 4%;
  width: 100%;
  left: 0;
  z-index: 102;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    position: relative;
    margin-bottom: 20px;
  }
`;

export const TooltipTrigger = styled.button`
  background: transparent;
  border-radius: 8px;
  display: flex;
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
`;

export const StyledTooltip = styled(Tooltip)<{
  $position: { top?: string; left?: string; bottom?: string; right?: string };
}>`
  width: 3%;
  height: 7%;
  position: absolute;
  left: ${({ $position }) => $position.left ?? "unset"};
  top: ${({ $position }) => $position.top ?? "unset"};
  bottom: ${({ $position }) => $position.bottom ?? "unset"};
  right: ${({ $position }) => $position.right ?? "unset"};
  white-space: normal;
  z-index: 1000;
  transform: translate(-50%, -50%);
`;

export const StyledText = styled.div`
  white-space: normal;
`;

export const TooltipStyles = createGlobalStyle`
  .how-unifi-tooltip > div {  
    width: 100%;
    height: 100%;
  }
`;

export const StyledTabs = styled(Tabs)`
  margin-top: 8px;

  .tabs {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #eeeff1;
  }

  .tab {
    > span {
      display: flex;
      align-items: center;
      color: #676f79;

      svg {
        bottom: 0;
        color: #808893;
        transition: color 0.15s linear;
        margin-right: 4px;
      }
    }

    &:hover:not(.selected-tab) {
      > span {
        color: ${({ theme }) => theme.colors.primaryBlue} !important;

        svg {
          color: ${({ theme }) => theme.colors.primaryBlue};
        }
      }
    }
  }

  .selected-tab {
    background: ${({ theme }) => theme.colors.primaryBlue} !important;

    > span {
      color: ${({ theme }) => theme.colors.white} !important;

      svg path {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;

export const Gradient = styled.div`
  position: absolute;
  border-radius: 16px 16px 0 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 120px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.1) 81%,
    rgba(0, 0, 0, 0) 100%
  );
  z-index: 102;

  @media (${BREAKPOINTS.TABLET_AND_DOWN}) {
    max-height: 600px;
  }
`;
